import { C } from '../data/constants.js';

export class Canvas {
  constructor(canvasElement) {
    this.el = canvasElement;
    this.ctx = canvasElement.getContext('2d');
    this.scale = 1;        // CSS pixels per logical pixel
    this.dpr = window.devicePixelRatio || 1;
    this.offsetX = 0;      // canvas offset from viewport left
    this.offsetY = 0;      // canvas offset from viewport top
    this.resize();
    window.addEventListener('resize', () => this.resize());
  }

  resize() {
    // Calculate scale to fit canvas in viewport while maintaining aspect ratio
    const aspect = C.CANVAS_W / C.CANVAS_H;
    const vw = window.innerWidth;
    const vh = window.innerHeight;
    const viewAspect = vw / vh;
    
    if (viewAspect > aspect) {
      // Viewport is wider than canvas — fit to height
      this.scale = vh / C.CANVAS_H;
    } else {
      // Viewport is taller — fit to width
      this.scale = vw / C.CANVAS_W;
    }

    // Set CSS display size
    const cssW = C.CANVAS_W * this.scale;
    const cssH = C.CANVAS_H * this.scale;
    this.el.style.width = cssW + 'px';
    this.el.style.height = cssH + 'px';

    // Set actual pixel resolution (for retina/DPR)
    this.dpr = window.devicePixelRatio || 1;
    this.el.width = C.CANVAS_W * this.dpr;
    this.el.height = C.CANVAS_H * this.dpr;

    // Scale context so we draw in logical coordinates
    this.ctx.setTransform(this.dpr, 0, 0, this.dpr, 0, 0);

    // Calculate canvas offset for coordinate mapping
    const rect = this.el.getBoundingClientRect();
    this.offsetX = rect.left;
    this.offsetY = rect.top;
  }

  // Convert a screen/client coordinate to logical game coordinate
  toLogicalX(clientX) {
    return (clientX - this.offsetX) / this.scale;
  }

  toLogicalY(clientY) {
    return (clientY - this.offsetY) / this.scale;
  }

  // Clear the entire canvas
  clear() {
    this.ctx.clearRect(0, 0, C.CANVAS_W, C.CANVAS_H);
  }
}
